/*
 * @Description:
 * @Author: lz
 * @Date: 2021-09-09 15:44:20
 * @LastEditTime: 2021-09-16 11:33:21
 * @LastEditors: lz
 */
import Request from '@/utils/request'
//获取用户信息
export function getUserInfo(param) {
  return Request.get('/user/info', param)
}
//获取未读消息
export function countDetails(param) {
  return Request.get('/message/countDetails', param)
}
//切换团队
export function changeOrg(orgId) {
  return Request.get(`/user/switchingOrg/${orgId}`)
}
//退出登录
export function logOut() {
  return Request.post(`user/logout`, {})
}

// 获取用户配置
export function getUserConfig() {
  return Request.get(`/getUserConfig`)
}

// 获取微信公众号动态二维码
export function getQrCodeInfo(data) {
  return Request.post('/getQrCodeInfo', data)
}

// 更新用户配置
export function updateUserConfig(data) {
  return Request.post(`/updateUserConfig`, data)
}

// 发送验证码
export function codePro(data) {
  return Request.post(`/codePro`, data)
}

// 校验验证码
export function codeCheckPro(data) {
  return Request.post(`/codeCheckPro`, data)
}
